module.exports = __webpack_public_path__ + "static/media/klaudia_l.6db3afe3.jpg";